import { createSlice } from "@reduxjs/toolkit";
import { createCMSLocalization, deleteCMSLocalization, fetchCMSLocalization, fetchCMSLocalizationTableColumnNames, updateCMSLocalization } from "./thunk";
import { toast } from "react-toastify";

const initialState = {
  preferences: {},
  screens: [],
  localization: [],
  tableColumnNames: [],
  ScreenTableColumnNames: [],
  loading: false,
  screenLoading: false,
  error: null,
};

const alitqanCmsSlice = createSlice({
  name: "alitqanCms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Fetch Localization API
      .addCase(fetchCMSLocalization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCMSLocalization.fulfilled, (state, action) => {
        state.loading = false;
        state.localization = action.payload;
      })
      .addCase(fetchCMSLocalization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Localization API
      .addCase(createCMSLocalization.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(createCMSLocalization.fulfilled, (state, action) => {
        // state.loading = false;
        state.localization = [...action.payload.data, ...state.localization];
      })
      .addCase(createCMSLocalization.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Update Localization API
      .addCase(updateCMSLocalization.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updateCMSLocalization.fulfilled, (state, action) => {
        const index = state.localization.findIndex(
          (item) => item.ID === action.payload[0].ID
        );
      
        if (index !== -1) {
          state.localization[index] = action.payload[0]; 
        } else {
          console.warn("Item to update not found in localization array.");
        }
      })      
      .addCase(updateCMSLocalization.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Delete Localization API
      .addCase(deleteCMSLocalization.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(deleteCMSLocalization.fulfilled, (state, action) => {
        // state.loading = false;

        // Extract IDs from the payload
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.localization = state.localization.filter(
          (item) => !deletedIds.includes(item.ID)
        );
      })

      .addCase(deleteCMSLocalization.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Fetch Localization Table Column Names API
      .addCase(fetchCMSLocalizationTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCMSLocalizationTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchCMSLocalizationTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default alitqanCmsSlice.reducer;
